import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AgileSDKService } from '../services/agile-sdk.service';
import { HardwareRelationshipMappingInfo } from '../model/agile-file-upload-response';
import { DataService } from '../data.service';
import { HardwareRelationshipUpdateRequest } from '../model/hardware-relationship-update-request';
import { Router } from '@angular/router';


@Component({
  selector: 'app-hardware-relationship-mapping',
  templateUrl: './hardware-relationship-mapping.component.html',
  styleUrls: ['./hardware-relationship-mapping.component.css']
})
export class HardwareRelationshipMappingComponent implements OnInit,OnDestroy  {

  dropdownList = [];
  selectedItems = [];
  
  // selectedComponentValues:string[] = [];
  selectedComponentValues:string[] = [];

  // selectedPnPIds:string[] = [];
  selectedPnPIds:string[] = [];


  // osLangRequired:boolean = false;
  // initialOSLangRequired:boolean = false;


  partNumber:string='005CT';
  isLoading : boolean = true

  myDropDown: string;
  // filterOSText : string
  filterComponentText:string;

  // filterLangText : string
  filterPnpIdText:string;

  // filterOSLangText : string
  filterHardwarePnpMappingText:string;

  addedValues:string[] = [];

  hardwareRelInfo:HardwareRelationshipMappingInfo;
  // osLangMatrixForm = new FormGroup({
  //   operatingSystem : new FormControl(''),
  //   language : new FormControl(''),
  //   osLangMatrix : new FormControl('')
  // }
  // );

  harwareRelMappingForm = new FormGroup({
    componentId : new FormControl(''),
    pnpIdString : new FormControl(''),
    hardwarePnpIdMapping : new FormControl('')
  }
  );
  
  // operatingSystems = [ 
  // ]
  // Languages = [   
  // ]
  // PartOsLangSelections = [  
  // ]

  componentIDs = [ 
  ]
  PnpIds = [   
  ]
  hardwarePnpMappings = [  
  ]
  // @ViewChild('selectOSList', { static: false }) selectOSList: ElementRef;
  // @ViewChild('selectLangList', { static: false }) selectLangList: ElementRef;
  // @ViewChild('selectOSLangList', { static: false }) selectOSLangList: ElementRef;

  @ViewChild('selectComponentList', { static: false }) selectComponentList: ElementRef;
  @ViewChild('selectPnpIdList', { static: false }) selectPnpIdList: ElementRef;
  @ViewChild('selectHardwarePnpMapList', { static: false }) selectHardwarePnpMapList: ElementRef;

  // originalOperatingSystems = [];
  // originalLanguages: string[];
  // originalPartOsLangSelections: string[];
  // osLangSubscribe:Subscription;

  originalComponents = [];
  originalPnpIds: string[];
  originalHardwarePnpIdMapping: string[];
  hardwareRelSubscribe:Subscription;


  constructor(private agileService:AgileSDKService,private dataService:DataService,private router: Router) { }
  ngOnDestroy(): void {
    // throw new Error('Method not implemented.');
    if(this.hardwareRelSubscribe != undefined){
      this.hardwareRelSubscribe.unsubscribe();
    }
  }


  ngOnInit(): void {
    // this.loadOSLangValues('005CT');
    this.hardwareRelInfo = this.dataService.getHardwareRelInfo();

    console.log('Hardware Relationship Info ',this.hardwareRelInfo);
    if(this.hardwareRelInfo != undefined){
      this.componentIDs = this.originalComponents = this.hardwareRelInfo.componentIdsSet;
        this.PnpIds = this.originalPnpIds = this.hardwareRelInfo.pnpIdStringInfoSet;
        this.hardwarePnpMappings = this.originalHardwarePnpIdMapping = this.hardwareRelInfo.hardwarePnPMappingSet;
    }
    
  }
    onItemSelect(item: any) {
      console.log(item);
    }
    onSelectAll(items: any) {
      console.log(items);
    }

    
  onChangeOfOptionsOS(newGov) {
    console.log(newGov);
  }
  onChangeOfOptionsLang(newGov) {
    console.log(newGov);
  }
  onChangeOfOptionsOSLang(newGov) {
    console.log(newGov);
  }


  filterComponentItem(event) {
    console.log('In filter OS')
    if (!event) {
      this.componentIDs = this.originalComponents;
    } // when nothing has typed*/   
    if (typeof event === 'string') {
      console.log(event);
      this.componentIDs = this.originalComponents.filter(a => a.toLowerCase()
        .includes(event.toLowerCase()));
    }
    console.log(this.componentIDs.length);
    this.selectComponentList.nativeElement.size = this.componentIDs.length + 1;
  }

  filterPnpIdsItem(event) {
    if (!event) {
      this.PnpIds = this.originalPnpIds;
    } // when nothing has typed*/   
    if (typeof event === 'string') {
      console.log(event);
      this.PnpIds = this.originalPnpIds.filter(a => a.toLowerCase()
        .includes(event.toLowerCase()));
    }
    console.log(this.originalPnpIds.length);
    this.selectComponentList.nativeElement.size = this.componentIDs.length + 1;
  }

  filterHarwarePnpMapItem(event) {
    console.log('Here')
    if (!event) {
      this.hardwarePnpMappings = this.originalHardwarePnpIdMapping;
    } // when nothing has typed*/   
    if (typeof event === 'string') {
      console.log(event);
      this.hardwarePnpMappings = this.originalHardwarePnpIdMapping.filter(a => a.toLowerCase()
        .includes(event.toLowerCase()));
    }
    console.log(this.originalHardwarePnpIdMapping.length);
    this.selectHardwarePnpMapList.nativeElement.size = this.hardwarePnpMappings.length + 1;
  }


  // loadOSLangValues(partNumber:string)
  // {
  //   this.hardwareRelSubscribe = this.agileService.getOSLangValues(partNumber).subscribe(
  //     data => 
  //     {
  //       this.isLoading = false
  //       console.log('OS Lang Data ' ,data);
  //       this.componentIDs = this.originalComponents = data.availableOsValues;
  //       this.PnpIds = this.originalPnpIds = data.availableLangValues;
  //       this.hardwarePnpMappings = this.originalHardwarePnpIdMapping = data.partOsLangValues;
  //     }
  //   )
  // }

 

  selectHardwareMappingValues()
  {
    console.log('In select Hardware Mapping Values method ')
    
    this.selectedComponentValues = [this.harwareRelMappingForm.get('componentId').value];
    this.selectedPnPIds = [this.harwareRelMappingForm.get('pnpIdString').value]; 

    // if(this.harwareRelMappingForm.get('componentId').value.length > 0 )
    if(this.selectedComponentValues.length > 0 && this.selectedPnPIds.length == 0 )
    {
      console.log('Select atleast one PNP ID')
      window.alert('Select atleast one PNP ID');
    }else if(this.selectedComponentValues.length == 0 && this.selectedPnPIds.length > 0){
      console.log('Select atleast one Component Value ')
      window.alert('Select atleast one Component Value');
    }else if(this.selectedComponentValues.length == 0 && this.selectedPnPIds.length == 0){
      console.log('No value selected')
      window.alert('No value selected');
    }else
    {
      console.log('Compute the selected matrix list')

      // this.originalHardwarePnpIdMapping.filter
      // (
      //   (osLang) => 
      //   {
      //     console.log('osLang split ',osLang.split('::::')[0])
      //     if(this.selectedComponentValues.includes(osLang.split('::::')[0])){
      //       console.log('OS Exists')
      //     }
      //   }
      // )

      console.log()
    

      this.selectedComponentValues.forEach((comp) => {
        this.selectedPnPIds.forEach((pnpId) =>{
          if(this.hardwarePnpMappings == undefined){
            this.hardwarePnpMappings = [comp+"::"+pnpId]
          }else{
            let value = comp+"::"+pnpId
            if(this.hardwarePnpMappings.filter((mapVal) => {if(mapVal == value){return mapVal;}}).length ==0){
              this.hardwarePnpMappings.push(value);
            }
          }
        })
      })

      // this.selectedComponentValues =  this.selectedComponentValues.map((compValue,indx) => 
      // {

      //   for(let i=0;i<this.selectedPnPIds.length;i++){
      //     return compValue = compValue+"::"+this.selectedPnPIds[i];
      //   }
        
      //   // this.selectedComponentValues[indx] = osValue;
      // })
    //   if(this.hardwarePnpMappings == undefined){
    //   this.hardwarePnpMappings = this.originalHardwarePnpIdMapping  = this.selectedComponentValues;
    //   this.hardwarePnpMappings.forEach((value) => {this.addedValues.push(value)})
     
    // }else
    // {

    //   this.selectedComponentValues.forEach((value) => {
    //     if(this.hardwarePnpMappings.filter((mapVal) => {if(mapVal == value){return mapVal;}}).length ==0){
    //       this.hardwarePnpMappings.push(value);
    //     }
    //   })

      
     

      
    // }
    this.originalHardwarePnpIdMapping = this.hardwarePnpMappings;
      // this.harwareRelMappingForm.get('hardwarePnpIdMapping').setValue(this.selectedComponentValues);

    }
  }

  unselectHardwareMappingValues()
  {
    console.log('added values ',this.addedValues)
    console.log('In un-select Harware PNP mapping Values method ',this.harwareRelMappingForm.get('hardwarePnpIdMapping').value)
    let selectedPnpMappingVals:string[] = [];
    selectedPnpMappingVals = [this.harwareRelMappingForm.get('hardwarePnpIdMapping').value];
    selectedPnpMappingVals.forEach(value => {
      console.log('value ',value);
      let index = this.hardwarePnpMappings.indexOf(value);
      if(index != undefined && index >=0)
      {
        let removedVal = this.hardwarePnpMappings.splice(index,1);
        console.log(this.addedValues)
        console.log(removedVal.toString())
        console.log(this.addedValues.indexOf(removedVal.toString()))

        if(this.addedValues.indexOf(removedVal.toString()) >= 0)
        this.addedValues.splice(this.addedValues.indexOf(removedVal.toString()),1)
        // console.log('removed Val ',removedVal,' removed val [0] ',removedVal[0],' Index of ',this.addedValues.indexOf(removedVal[0]))
        // let removedFromAdded = this.addedValues.splice(this.addedValues.indexOf(removedVal[0],1))
        // console.log('removed from added ',removedFromAdded)
      }
    });
  this.originalHardwarePnpIdMapping = this.hardwarePnpMappings;
  }
  confirmHarwareRelMappingValues()
  {
    console.log('Component ID Values',this.harwareRelMappingForm.get('componentId').value);
    console.log('Lang Values',this.harwareRelMappingForm.get('pnpIdString').value);
    console.log('Hardware RelMapping values ',this.harwareRelMappingForm.get('hardwarePnpIdMapping').value)
    // console.log('OS-Lang Matrix Values changed? ',this.valuesUpdated);
    // console.log('os lang required ',this.osLangRequired)
    console.log('added values ',this.addedValues)
    if(this.addedValues.length>0){
      console.log('not Same')
      let message = 'Do you want to proceed with the Mapping updates: '+this.addedValues;
      // if(this.initialOSLangRequired != this.osLangRequired)
      // {
      //   message = message+" and OS Lang Required to: "+this.osLangRequired
      // }
      let result = window.confirm('Do you want to proceed with the updates: '+this.addedValues)
      console.log('result ',result)
      if(result)
      {
        let hardwareRelUpdateReq:HardwareRelationshipUpdateRequest = {
          partNumber:this.partNumber,
          hardwareRelationshipMappings:this.originalHardwarePnpIdMapping
        };
        console.log('Hardware Rel update req ',hardwareRelUpdateReq)
        // call the post service to update the values
        console.log('sending the part hardware relationship mapping selections ',this.hardwarePnpMappings)
        this.agileService.updateHardwareRelationshipMapping(hardwareRelUpdateReq).subscribe((response) => {
          this.isLoading =false;
          if(response){
            window.alert('Updated values in Agile')
            this.router.navigate(['home'], { skipLocationChange: true })
          }else{
            window.alert('Unable to update values in Agile')
            this.router.navigate(['home'], { skipLocationChange: true })
          }
         
          
        },
         (error) => {
           this.isLoading = false;
           
          console.log('error ',error)
          
        }
        
        
        )
        
        // let partOsLangReq:PartOSLangRequest= {partNumber:this.partNumber,osLangMatrixValues:this.hardwarePnpMappings,hasOsLangRequired:(this.osLangRequired ?'Yes':'No'),updateOSValues:true};
        // this.agileService.postOSLangValues(partOsLangReq).subscribe((updated) => {
        //   if(updated)
        //   {
        //     window.alert('Successfully updated the OS Lang Values')
        //   }else{
        //     window.alert('Unable to update the OS Lang Values')
        //   }
        // });
      }
    }else{
      console.log('Same')
      // if(this.initialOSLangRequired != this.osLangRequired)
      // {
        let message = 'Do you want to proceed with the updates ';
        // if(this.osLangRequired)
        // {
        //   message = message+"'Yes'";
        // }else{
        //   message = message+"'No'";
        // }
        console.log('Hardware Rel Mappings ',this.hardwarePnpMappings)
        console.log('original Hardware Rel mapping ',this.originalHardwarePnpIdMapping)
        let result = window.confirm(message)
        if(result)
        {
          // call the API to update the values

          let hardwareRelUpdateReq:HardwareRelationshipUpdateRequest = {
            partNumber:this.partNumber,
            hardwareRelationshipMappings:this.originalHardwarePnpIdMapping
          };
          
          console.log('Hardware Rel update req ',hardwareRelUpdateReq)

          this.isLoading = true;
          this.agileService.updateHardwareRelationshipMapping(hardwareRelUpdateReq).subscribe((response) => {
            this.isLoading =false;
            if(response){
              window.alert('Updated values in Agile')
              this.router.navigate(['home'], { skipLocationChange: true })
            }else{
              window.alert('Unable to update values in Agile')
              this.router.navigate(['home'], { skipLocationChange: true })
            }
           
            
          },
           (error) => {
             this.isLoading = false;
             
            console.log('error ',error)
            
          }
          
          
          )
          // let partOsLangReq:PartOSLangRequest= {partNumber:this.partNumber,osLangMatrixValues:[],hasOsLangRequired:(this.osLangRequired ?'Yes':'No'),updateOSValues:false};
          // this.agileService.postOSLangValues(partOsLangReq).subscribe(
          //   (updated) => {
          //     if(updated)
          //     {
          //       window.alert('Successfully updated the OS Lang Values')
          //     }else{
          //       window.alert('Unable to update the OS Lang Values')
          //     }
          //   }
          // );
        }
      // }else{
      // window.alert('No changes to the existing values ')}
    }
    
  }

  onCancel(){
    console.log('Routing to home ')
    this.router.navigate(['home'],{skipLocationChange:true})
  }
}
